const postdata = [
    {
        title: "September",
        text: "September...Nulla dignissim ultrices lacinia. Etiam commodo venenatis nisl, ut rutrum ligula aliquet eu. Pellentesque nec velit non est cursus efficitur. Pellentesque nec velit non est cursus efficitur. Pellentesque nec velit non est cursus efficitur. Pellentesque nec velit non est cursus efficitur.",
        image: "https://cdn.pixabay.com/photo/2019/09/15/20/26/autumn-4479342_960_720.jpg",
        id: 1,
        url: '/posts/september'
    },
    {
        title: "October",
        text: "October...Nulla dignissim ultrices lacinia. Etiam commodo venenatis nisl, ut rutrum ligula aliquet eu. Pellentesque nec velit non est cursus efficitur.",
        image: "https://cdn.pixabay.com/photo/2018/10/22/19/19/foliage-3766097_960_720.jpg",
        id: 2,
        url: '/posts/october'
    },
    {
        title: "November",
        text: "November...Nulla dignissim ultrices lacinia. Etiam commodo venenatis nisl, ut rutrum ligula aliquet eu. Pellentesque nec velit non est cursus efficitur.",
        image: "https://cdn.pixabay.com/photo/2018/12/04/15/37/autumn-3855864_960_720.jpg",
        id: 3,
        url: '/posts/november'
    },
    {
        title: "December",
        text: "December...Nulla dignissim ultrices lacinia. Etiam commodo venenatis nisl, ut rutrum ligula aliquet eu. Pellentesque nec velit non est cursus efficitur.",
        image: "https://cdn.pixabay.com/photo/2018/05/21/17/18/snow-3418819_960_720.jpg",
        id: 4,
        url: '/posts/december'
    },
    {
        title: "January",
        text: "Lomaaaaaa! Nulla dignissim ultrices lacinia. Etiam commodo venenatis nisl, ut rutrum ligula aliquet eu. Pellentesque nec velit non est cursus efficitur.",
        image: "https://cdn.pixabay.com/photo/2019/08/02/12/52/carvoeiro-4379670_960_720.jpg",
        id: 5,
        url: '/posts/january'
    },
]

export default postdata;